import { render, staticRenderFns } from "./ModalFinanceiroRegraIndicacao.vue?vue&type=template&id=2ae3abbc&scoped=true"
import script from "./ModalFinanceiroRegraIndicacao.vue?vue&type=script&lang=ts"
export * from "./ModalFinanceiroRegraIndicacao.vue?vue&type=script&lang=ts"
import style0 from "./ModalFinanceiroRegraIndicacao.vue?vue&type=style&index=0&id=2ae3abbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae3abbc",
  null
  
)

export default component.exports